module.exports = __webpack_public_path__ + "img/sy_18.922b61f0.png";